<template>
	<div class="game-container">
		<div class="nes-balloon from-left bubble-block" id="top-bubble">

		</div>
		<div class="nes-container is-dark welcome-dialog main-block">
			<div class="block-container">
				<div v-if="activeMenu === 'presentation'" class="presentation">
				<img src="~@/assets/img/benjamin.png" alt="" />
				<div>
					<p>
						Depuis tout petit, je suis fan de tout ce qui touche à
						la science et aux technologies. J'ai fait de cette
						passion mon métier ! Je suis aujourd'hui un développeur
						full-stack en agence de communication, travaillant
						principalement sur du e-commerce, découvrant de
						nouvelles technos sur mon temps libre.
					</p>
				</div>
			</div>
			<div v-if="activeMenu === 'more'" class="more">
				<div>
					<p>
						Je suis né au pied du Mont Blanc, dans la vallée de
						l'Arve. Grandir dans cet environnement m'a donné le gout
						de la montagne et de la nature, tant en hiver qu'en été
						! Cela m'a aussi inculqué des notions d'écologie en me
						faisant prendre conscience que cet environnement est
						précieux et qu'il faut le préserver.
					</p>
					<p>
						J'adore cuisiner sur mon temps libre, surtout pour faire
						plaisir à mes proches. Découvrir de nouvelles recettes,
						les réussir après parfois plusieurs échecs, mais sans
						abandonner, je déteste ne pas réussir à faire quelque
						chose ! Grand fan de jeux-vidéo depuis que je sais lire,
						c'est aujourd'hui une passion, mais aussi une source
						d'inspiration dans mon travail.
					</p>
					<p>
						Curieux depuis que je suis tout petit, j'ai toujours
						aimé apprendre, découvrir, particulièrement lorsque ça
						touche à la science et aux nouvelles technologies !
					</p>
				</div>
			</div>
			<div v-if="activeMenu === 'hardskills'" class="hardskills">
				<div class="skills-container">
					<div class="skill">
						<img src="~@/assets/img/pixel/prestashop.png" alt="" />
						<span>PrestaShop</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/wordpress.png" alt="" />
						<span>WordPress</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/shopify.png" alt="" />
						<span>Shopify</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/nuxt.png" alt="" />
						<span>Nuxt</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/vuejs.png" alt="" />
						<span>Vue.js</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/symfony.png" alt="" />
						<span>Symfony</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/react.png" alt="" />
						<span>React</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/tailwind.png" alt="" />
						<span>TailwindCSS</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/strapi.png" alt="" />
						<span>Strapi</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/nodejs.png" alt="" />
						<span>Node.js</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/astro.png" alt="" />
						<span>Astro</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/docker.png" alt="" />
						<span>docker</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/graphql.png" alt="" />
						<span>GraphQL</span>
					</div>
				</div>
			</div>
			<div v-if="activeMenu === 'softskills'" class="softskills">
				<div class="skills-container">
					<div class="skill">
						<img src="~@/assets/img/pixel/ruler.png" alt="" />
						<span>UI/UX</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/figma.png" alt="" />
						<span>Figma</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/photoshop.png" alt="" />
						<span>Photoshop</span>
					</div>
					<div class="skill">
						<img
							src="~@/assets/img/pixel/communication.png"
							alt=""
						/>
						<span>Communication</span>
					</div>
					<div class="skill">
						<img src="~@/assets/img/pixel/eco.png" alt="" />
						<span>Éco-conception</span>
					</div>
				</div>
			</div>
			</div>
		</div>
		<div class="nes-container is-dark welcome-dialog choice-block">
			<div class="choices">
				<div :class="getActiveMenu('presentation')" @click="goToMenu('presentation')">
					Présentation
				</div>
				<div :class="getActiveMenu('more')" @click="goToMenu('more')">
					Un peu plus sur moi
				</div>
				<div :class="getActiveMenu('hardskills')" @click="goToMenu('hardskills')">
					Compétences techniques
				</div>
				<div :class="getActiveMenu('softskills')" @click="goToMenu('softskills')">
					Compétences générales
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Game",
	data() {
		return {
			activeMenu: "presentation",
		};
	},
	mounted(){
		this.printLetterByLetter('top-bubble', 'Bonjour ! Je suis Benjamin, développeur full stack passionné', 40);
	},
	methods: {
		goToMenu: function (menu) {
			document.querySelector('.block-container').scrollTop = 0;
			this.activeMenu = menu;
		},
		getActiveMenu: function(menu) {
			let classMenu = 'cursor-choice';
			if (menu == this.activeMenu) {
				classMenu += ' active';
			}
			return classMenu;
		},
		printLetterByLetter: function (destination, message, speed) {
			let i = 0;
			let interval = setInterval(function () {
				document.getElementById(destination).innerHTML +=
					message.charAt(i);
				i++;
				if (i > message.length) {
					clearInterval(interval);
				}
			}, speed);
		},
	},
};
</script>
<style lang="scss">
.game-container {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	&:before {
		content: "";
		position: absolute;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.3;
		top: 0;
		left: 0;
	}
	.nes-balloon {
		max-width: 900px;
	}
	.welcome-dialog {
		max-width: 900px;
		width: 100%;
		&.main-block {
			max-height: 50vh;
			.block-container {
				max-height: 100%;
				padding: 1rem;
				overflow-y: auto;
				overflow-x: hidden;
				&::-webkit-scrollbar {
					width: 5px;
				}
				&::-webkit-scrollbar-track {
					background-color: black;
				}
				&::-webkit-scrollbar-thumb {
					background-color: white;
				}
			}
		}
		.hardskills,
		.softskills {
			.skills-container {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 20px;
				.skill {
					span,
					img {
						display: block;
						margin: 0 auto;
						text-align: center;
					}
					img {
						margin-bottom: 0.5rem;
					}
				}
				@media screen and (max-width: 768px) {
					font-size: 10px;
					grid-template-columns: repeat(2, 1fr);
					gap: 40px 10px;
				}
			}
		}
		.presentation {
			display: flex;
			align-items: center;
			gap: 20px;
			img {
				max-width: 25%;
				transition-property: none;
				animation: avatar 3s steps(2) infinite;
			}
			@media screen and (max-width: 768px) {
				display: block;
				img {
					max-width: 80%;
					margin: 0 auto 20px;
					display: block;
				}
			}
			@keyframes avatar {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(-20px);
				}
			}
			p {
				margin-bottom: 0;
			}
		}
		.choices {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			.cursor-choice {
				position: relative;
				padding: 10px 0 10px 30px;
				&:before {
					display: none;
					width: 3px;
					height: 3px;
					color: #fff;
					box-shadow: 3px 3px, 6px 3px, 9px 3px, 12px 3px, 15px 3px,
						18px 3px, 21px 3px, 3px 6px, 6px 6px, 9px 6px, 12px 6px,
						15px 6px, 18px 6px, 21px 6px, 6px 9px, 9px 9px, 12px 9px,
						15px 9px, 18px 9px, 6px 12px, 9px 12px, 12px 12px,
						15px 12px, 18px 12px, 9px 15px, 12px 15px, 15px 15px,
						12px 18px;
					position: absolute;
					top: 32px;
					left: 0;
					pointer-events: none;
					transform: rotate(270deg);
					content: "";
					@media screen and (max-width: 768px) {
						top: 30px;
					}
				}
				&:hover,
				&.active {
					&:before {
						display: block;
					}
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		position: absolute;
		padding: 30px;
		font-size: 12px;
	}
	@media screen and (max-width: 768px) {
		.main-block {
			padding: 0;
			height: 50vh;
		}
		.choice-block {
			padding: 1rem 0.5rem;
			.choices {
				font-size: 12px;
				display: block;
			}
		}
	}
}
</style>
